import React, { useEffect, useState, useCallback } from 'react'
import { useHistory } from "react-router-dom";
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { Button } from '@mui/material';
import { LoaderScreen } from '../../../components/LoaderScreen';
import CreateIcon from '@mui/icons-material/Create';
import { ButtonBack } from '../Util/ButtonBack';
import AddIcon from '@mui/icons-material/Add';
import GroupsIcon from '@mui/icons-material/Groups';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TuneIcon from '@mui/icons-material/Tune';
import { SalaModal } from './SalaModal';

const getTipoSala = (tipo) => {
    switch (tipo) {
        case "N":
            return "NORMAL";
        case "A":
            return "AUTORIZADO";
        default:
            return tipo;
    }
};

export const CatalogoSalaScreen = () => {

    const history = useHistory();
    const [data, setData] = useState([]);
    const [modal, setModal] = useState({ open: false, editId: null });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const cargarListado = useCallback(() => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(`Sala/Listado`)
            .then((result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setData(result);
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("LISTADO SALAS", JSON.stringify(error), "error");
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        cargarListado();
    }, [cargarListado]);

    const onAgregar = () => setModal({ open: true, editId: null });
    const onEditar = (id) => setModal({ open: true, editId: id });
    const onCerrarModal = () => setModal({ open: false, editId: null });

    const onActividades = (id) => {
        history.push(`/Permisos/CatSalaActividades/${id}`);
    };

    const onResponsables = (id) => {
        history.push(`/Permisos/CatSalaResponsables/${id}`);
    };

    const onCamposExtra = (id) => {
        history.push(`/Permisos/CatSalaCamposExtra/${id}`);
    };

    return (
        <PlantillaScreen
            titulo={"CATALOGO DE SALAS"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >
            <LoaderScreen loader={loader} />

            <div className='sac-contenido'>

                <div className='sacc-agregar'>
                    <Button
                        variant="contained"
                        onClick={onAgregar}
                    >
                        <AddIcon /> Agregar
                    </Button>
                </div>

                <div className="sacc-tabla sacc-tabla-salas scroll">

                    <table className='sacct-container'>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>NOMBRE SALA</th>
                                <th>TIPO DE SALA</th>
                                <th>USUARIO</th>
                                <th>ESTADO</th>
                                <th>EDITAR</th>
                                <th>RESPONSABLES</th>
                                <th>ACTIVIDADES</th>
                                <th>CAMPOS EXTRA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((menu) => (
                                <tr key={menu.idsala}>
                                    <td><span className="sacct-id-chip">{menu.idsala}</span></td>
                                    <td>{menu.nombresala}</td>
                                    <td>{getTipoSala(menu.tiposala)}</td>
                                    <td>{menu.usuario}</td>
                                    <td>
                                        <span className={`status-badge ${menu.estado ? "status-badge--activo" : "status-badge--inactivo"}`}>
                                            {menu.estado ? "ACTIVO" : "INACTIVO"}
                                        </span>
                                    </td>

                                    <td className='sa-editar'>
                                        <CreateIcon
                                            style={{ cursor: "pointer", color: "#ed7d31" }}
                                            onClick={() => onEditar(menu.idsala)}
                                        />
                                    </td>

                                    <td>
                                        <Button
                                            className='button-responsables'
                                            onClick={() => onResponsables(menu.idsala)}
                                        >
                                            <GroupsIcon /> Responsables
                                        </Button>
                                    </td>
                                    <td>
                                        <Button
                                            className='button-actividades'
                                            onClick={() => onActividades(menu.idsala)}
                                        >
                                            <AssignmentIcon /> Actividades
                                        </Button>
                                    </td>
                                    <td>
                                        <Button
                                            className='button-campos-extra'
                                            onClick={() => onCamposExtra(menu.idsala)}
                                        >
                                            <TuneIcon /> Campos extra
                                        </Button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>

            </div>

            <SalaModal
                open={modal.open}
                editId={modal.editId}
                onClose={onCerrarModal}
                onSaved={cargarListado}
            />

            <ButtonBack path={'/Permisos/Main'} ></ButtonBack>

        </PlantillaScreen>
    )
}
